export const apiendpoints = {
    // For_Authentication
    LOGIN_API: "/api/Auth/Login",
    SIGNUP_API: "/api/Account/Signup",
    FORGOT_PASSWORD: "/api/Account/ForgotPassword",

    IS_EMAIL_EXIST: "/api/Auth/IsEmailExist",
    
    // For_MASTER 
    ALL_LOCATIONS: "api/Masters/GetMasterLocationCity",
    GET_CUISINES_LIST: "/api/Masters/GetMasterCuisines",
    GET_MASTER_SPECIALITY:"/api/Masters/GetMasterSpeciality",
    
    // For_Profile
    GET_PROFILE_DETAILS: "/api/UserProfile/GetUserProfile",
    UPDATE_CONTACT: "/api/UserProfile/UpdateContact",
    UPDATE_PASSWORD: "/api/UserProfile/UpdatePassword",
    UPDATE_PREFERENCE: "/api/UserProfile/UpdatePreferences",
    DELETE_PROFILE: "/api/UserProfile/DeleteMyProfile",

    // For_Rewards
    GET_REWARDS: "/api/Rewards/GetRewards",
    GET_REWARDS_DETAILS:"api/Rewards/GetRewardDetail",
    CLAIM_REWARDS:"/api/Rewards/ClaimReward",
    GIFT_REWARDS:"/api/Rewards/GiftCard",
    MY_REWARDS:"/api/Rewards/MyReward",


    // NOTIFICATIONS 
    GET_NOTIFICATIONS: "/api/Notification/GetNotifications",
    GET_NOTIFICATIONS_DETAILS: "/api/Notification/GetNotificationDetails",
    READ_NOTIFICATIONS: "/api/Notification/ReadNotification",
    DELETE_NOTIFICATION: "api/Notification/DeleteNotification",

    // ALL_LOCATIONS
    GET_ALL_LOCATIONS : "/api/Location/GetAllLocations",


    // SignUp on Quad System 
    Quad_System_SIGN_UP_API: "https://www.quadranet.co.uk/QuadRewardsGiftCards/ExternalCallsAPI.aspx",



    // GET_QUADRANET_PROFILE
    GET_QUADRANET_PROFILE : "/api/UserProfile/GetQuadUserProfile",


   //Booking_Form
    BOOKINGS : "/api/Booking/GetAll",

   //Update_Tier
   UPDATE_TIER: "/api/UserProfile/UpdateTier",

      // Content API
      CONTENT_API: "/api/Content/GetContent",

}

